import { render, staticRenderFns } from "./BranchesTable.vue?vue&type=template&id=c40712bc&"
import script from "./BranchesTable.vue?vue&type=script&lang=js&"
export * from "./BranchesTable.vue?vue&type=script&lang=js&"
import style0 from "./BranchesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports